export function converterPesoKgParaNumero(valor: unknown): number | null {
	if (valor === '' || valor === undefined || valor === null) {
		return null;
	}

	if (typeof valor === 'string') {
		const t = valor.trim().replace(/,/g, '.');
		if (t === '' || t === '.') {
			return null;
		}

		const n = Number(t);
		return Number.isFinite(n) ? n : null;
	}

	const n = Number(valor);
	return Number.isFinite(n) ? n : null;
}

export function converterPesoKgParaNumeroTransporte(valor: unknown): number | null {
	if (valor === '' || valor === undefined || valor === null) {
		return null;
	}

	if (typeof valor === 'string') {
		const t = valor.trim();
		if (t === '' || t === '.') {
			return null;
		}
		if (t.includes(',')) {
			return null;
		}

		const n = Number(t);
		return Number.isFinite(n) ? n : null;
	}

	const n = Number(valor);
	return Number.isFinite(n) ? n : null;
}

export function formatPesoKgValorInicial(valor: unknown): string {
	if (valor === null || valor === undefined || valor === '') {
		return '';
	}

	const n =
		typeof valor === 'number' ? valor : converterPesoKgParaNumero(String(valor));

	if (n === null || !Number.isFinite(n)) {
		return '';
	}

	return n.toFixed(2);
}
